import { LoggerCategoryEnum } from '@nab/nab-x-sdk-core';
import { consoleTransport } from './transports';
import { Logger } from './Logger';

export const loggerWrapperAttribute = 'data-nabx-logger-class';
export const logLevelCookieName = 'nabxLoggerConsoleLevel';
export const consoleDisabledCookieName = 'nabxLoggerConsoleDisabled';

export function configureDefaultSDKLogger() {
    return new Logger({
        transports: {
            [LoggerCategoryEnum.default]: consoleTransport,
            [LoggerCategoryEnum.analytics]: consoleTransport,
            [LoggerCategoryEnum.diagnostic]: consoleTransport,
            [LoggerCategoryEnum.api]: consoleTransport,
            [LoggerCategoryEnum.ui]: consoleTransport
        },
        appName: 'sdk.logger',
        appVersion: '0.0.0',
        autoPost: false,
        platform: 'nab-x-sdk',
        environment: 'sdk',
        wrapper: undefined
    });
}
